import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=2d33ea29&scoped=true&"
import script from "./SocialButton.vue?vue&type=script&lang=js&"
export * from "./SocialButton.vue?vue&type=script&lang=js&"
import style0 from "./SocialButton.vue?vue&type=style&index=0&id=2d33ea29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33ea29",
  null
  
)

export default component.exports